<nav *ngIf="pageCount > 1"
     class="ng-pagination-container">
    <ul class="ng-pagination">
        <li class="ng-page-item">
            <button type="button"
                    class="ng-page ng-page--control"
                    aria-label="Предыдущая страница"
                    [disabled]="!isPrevAvailable"
                    (click)="onPrev()">
                <img src="/x-assets/img/icons/icon-prev-blue.svg" alt="" class="ng-page-control-icon">
            </button>
        </li>
        <li *ngFor="let page of pages; trackBy: trackByPage"
            class="ng-page-item">
            <span *ngIf="page === 'ellipsis'; else pageButton"
                  class="ng-page-ellipsis">...</span>
            <ng-template #pageButton>
                <button type="button"
                        [class.active]="currentPage === page"
                        class="ng-page"
                        (click)="onClick(page)">
                    {{ page }}
                </button>
            </ng-template>
        </li>
        <li class="ng-page-item">
            <button type="button"
                    class="ng-page ng-page--control"
                    aria-label="Следующая страница"
                    [disabled]="!isNextAvailable"
                    (click)="onNext()">
                <img src="/x-assets/img/icons/icon-prev-blue.svg" alt="" class="ng-page-control-icon ng-page-control-icon--next">
            </button>
        </li>
    </ul>
</nav>
